import Vue from "vue";
import Vuex from "vuex";
import * as auth from "@/store/modules/auth.js";
import * as roles from "@/store/modules/roles.js";
import * as users from "@/store/modules/users.js";
import * as logs from "@/store/modules/logs.js";
// import * as distritos from "@/store/modules/distritos.js";
import * as oficios from "@/store/modules/oficios.js";
import * as contestacion from "@/store/modules/contestacion.js";
import * as juzgados from "@/store/modules/juzgados.js";
import * as municipios from "@/store/modules/municipios.js";
import * as expedientes from "@/store/modules/expedientes.js";
import * as salas from "@/store/modules/salas.js";
import * as firma from "@/store/modules/firma.js";
import * as tocas from "@/store/modules/tocas.js";
import * as buzon from "@/store/modules/buzon.js";
import * as sentencias from "@/store/modules/sentencias.js";
import * as amparos from "@/store/modules/amparos.js";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,
    roles,
    users,
    logs,
    // distritos,
    oficios,
    contestacion,
    juzgados,
    municipios,
    expedientes,
    salas,
    firma,
    tocas,
    buzon,
    sentencias,
    amparos
  },
  state: {
    layout: "dashboard-layout",
    loading: false,
    notification: "",
    maintenance: {
      active: false,
      message: ""
    }
  },
  mutations: {
    SET_NOTIFICATION(state, payload) {
      // payload = { tipo: 'success', message:'el mensaje de success'}
      state.notification = Object.assign({}, payload);
    },
    CLEAR_NOTIFICATION(state, payload) {
      state.notification = { tipo: "", message: "" };
    },
    SET_LOADING(state, payload) {
      state.loading = payload;
    },
    SET_LAYOUT(state, newLayout) {
      state.layout = newLayout;
    },
    SET_MAINTENANCE(state, payload) {
      state.maintenance = {
        active: true,
        message: payload.message || "Sistema en mantenimiento"
      };
    }
  },
  actions: {},
  getters: {}
});
